module.exports = __webpack_public_path__ + "static/media/PALL.06a0bcdb.png";